///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.promos = abcsetup.promos || {};
abcsetup.promos.vendor_show = abcsetup.promos.vendor_show || {};

///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Variables
//
///////////////////////////////////////////////////////////////////////////////////////////////////

abcsetup.promos.vendor_show.itemTimeout = null;
abcsetup.promos.vendor_show.items = [];
abcsetup.promos.vendor_show.promo_attributes = {};
abcsetup.promos.vendor_show.total_items = 0;
///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.promos.vendor_show = {
    promo_type: null,

    init: function() {

        this.promo_type = JSON.parse($('#promo_type').text());

        if (this.promo_type.is_gnp_type) {
            abcsetup.promos.gnp.common.init();
            return true;
        }
        abcsetup.setTitle('Edit Promotion');
        this.total_items = 0;
        // Set the global item var
        abcsetup.item = JSON.parse($('form.manage-promotions #item_object').val());
        this.promo_attributes =  {
            promo :  {
                type: (abcsetup.item.promo) ? abcsetup.item.promo.type : (abcsetup.item.type ? abcsetup.item.type : '')

            },
        }
        var editable_status = ["vendor_in_process","cm_rejected",'reject_approved']

        abcsetup.promos.form_manager.form = $('form.manage-promotions');
        var is_able_to_edit = !abcsetup.item.promo_attr[0] || !abcsetup.item.promo_attr[0].review_status || (abcsetup.item.promo_attr[0] && editable_status.includes(abcsetup.item.promo_attr[0].review_status));

        abcsetup.promos.form_manager.setFormItems(true);

        $(function() {
            $('.btn').attr('disabled',true)
            $('btn-remove-item').attr('disabled',true)
        });

        // Init Promo Items
        this._initPromoItems();

        $(function(){
            if($('#add_items').is(':visible')) {
                // Show the Promo Item table
                $('.row.promo_items').show();
            }
        })

    },


    /**
     * fieldError callback from _jquery.fieldValidate
     */
    fieldError: function() {

        if (this.promo_type.is_gnp_type) {
            var errorField = $('form').find('.invalid').first();
            abcsetup.unblockUI();
        } else {
            var errorField = $('form.manage-promotions').find('.invalid').first();

            // Focus on the tab where the error occurred
            var tab = errorField.closest('div.tab-pane');
            if (!tab.hasClass('active')){
                $('div.tab-pane').removeClass('active').removeClass('show');
                $("li.nav-item > a").removeClass('active').removeClass('show');
                tab.addClass('active').addClass('show')
                $("li.nav-item #"+tab.attr('id')+"-tab").addClass('active').addClass('show');
                errorField.trigger('focus');
            }
        }
    },

    /**
     * Init the PromoItems
     */
    _initPromoItems: function() {
        if (abcsetup.item.promo_items && abcsetup.item.promo_items.length) {
            $(abcsetup.item.promo_items).each(function() {
                var html = '';
                html = '<tr class="promo_item">';
                html = html + '<input type="hidden" id="item_id_'+this.a_b_c_item.id+'" name="promo_item[]" class="item_id" value="'+this.a_b_c_item.id+'">';
                html = html + '<td></td>';
                html = html + '<td>' + this.a_b_c_item.sap_num + '</td>';
                html = html + '<td>' + (this.a_b_c_item.upc11 || '') + '</td>';
                html = html + '<td>' + this.abc_item + '</td>';
                html = html + '<td>' + this.a_b_c_item.mfr_prod_code + '</td>';
                html = html + '<td>' + this.a_b_c_item.category_name + '</td>';
                html = html + '<td>' + this.a_b_c_item.mat_descr + '</td>';
                html = html + '</tr>';

                // Append the new row
                $('#promo_items_table').append(html);
                abcsetup.promos.vendor_show.total_items++;
            });
        }
    },
}